module.exports = __webpack_public_path__ + "static/media/code-quiz.f3637609.png";